// src/utils/excelUtils.js
import * as XLSX from "xlsx";

export const exportToExcel = (data, fileName) => {
  // Convert data to worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);
  
  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  // Write the workbook to file
  XLSX.writeFile(workbook, fileName);
};
